(function(scope){
  'use strict';
  function shortTitle(value){
    let title=String(value||'').split(' — ')[0].split(' – ')[0].replace(/^Goal Five |^Alpha Country /,'').trim();
    if(title.includes(' | '))title=title.split(' : ')[0].replaceAll(' | ',' ').toLowerCase().split(/\s+/).map(word=>word.charAt(0).toUpperCase()+word.slice(1)).join(' ');
    return title;
  }
  function scopedSearch(query){
    const terms={legging:'leggings',leggings:'leggings',short:'shorts',shorts:'shorts',jogger:'joggers',joggers:'joggers','sports bra':'sports-bras','sports bras':'sports-bras','tank top':'tank-tops','tank tops':'tank-tops',sunglasses:'sunglasses'};
    const normalized=String(query||'').trim().toLowerCase().replace(/’/g,"'").replace(/\s+/g,' '),match=normalized.match(/^(men(?:'s|s)?|women(?:'s|s)?|unisex) (.+)$/);
    const category=terms[match?match[2]:normalized];
    if(!category)return query;
    const audience=match?(match[1].startsWith('women')?'women':match[1].startsWith('men')?'men':'unisex'):'';
    return (audience?'tag:motion-'+audience+' AND ':'')+'tag:motion-kind-'+category;
  }
  const optionName = option => typeof option === 'string' ? option : option.name;
  function canonicalSize(value){
    const key=String(value||'').toLowerCase().replace(/[\s_-]/g,'');
    return ({xxsmall:'XXS',xsmall:'XS',extrasmall:'XS',small:'S',medium:'M',large:'L',xlarge:'XL',extralarge:'XL',xxlarge:'XXL','2xl':'XXL',xxxlarge:'XXXL','3xl':'XXXL'})[key]||value||'';
  }
  const optionValues = (product,index) => [...new Set(product.variants.map(v=>v.options[index]))];
  const matchVariant = (product,selected) => selected.length===product.options.length && selected.every(Boolean) ? product.variants.find(v=>v.options.every((value,index)=>value===selected[index])) : undefined;
  // A variant link selects every option of that variant. Color-only links (product cards, marked
  // with #aw-pick-color) keep the color and leave the size for the shopper to choose.
  function initialSelection(product,variantId,color,colorOnly){
    const linked=variantId?product.variants.find(v=>String(v.id)===String(variantId)):null;
    if(linked&&!colorOnly)return linked.options.slice();
    const base=linked||product.variants.find(v=>v.available)||product.variants[0];
    return product.options.map((option,index)=>{
      const name=optionName(option).toLowerCase();
      if(/size|taille|mărime/.test(name))return '';
      if(/colou?r/.test(name))return optionValues(product,index).includes(color)?color:base.options[index];
      const values=optionValues(product,index);return values.length===1?values[0]:'';
    });
  }
  function optionAvailable(product,index,value,selected){
    return product.variants.some(v=>v.available&&v.options[index]===value&&v.options.every((x,i)=>i===index||!selected[i]||x===selected[i]));
  }
  function normalizeWishlist(raw){
    if(!Array.isArray(raw))return [];
    return [...new Set(raw.filter(x=>typeof x==='string'&&/^[a-z0-9][a-z0-9®-]*$/.test(x)))].slice(0,80);
  }
  function createQueue(){
    let tail=Promise.resolve();
    return task=>{const operation=tail.then(task,task);tail=operation.catch(()=>{});return operation;};
  }
  function matchingVariants(card,filters){
    const has=(name,value)=>!filters[name]?.length||filters[name].includes(value);
    return card.variants.filter(v=>has('size',v.size)&&has('availability',v.available?'1':'0')&&has('sale',v.compareAt==null?card.sale:Number(v.compareAt)>v.price?'1':'0')&&(filters.min===''||filters.min==null||v.price>=Number(filters.min)*100)&&(filters.max===''||filters.max==null||v.price<=Number(filters.max)*100));
  }
  function matchesCard(card,filters){
    const has=(name,value)=>!filters[name]?.length||filters[name].includes(value);
    if(filters.audience?.length&&!filters.audience.some(value=>(card.audiences||['unspecified']).includes(value)))return false;
    const facetsMatch=['feature','fit','rise','activity'].every(key=>!filters[key]?.length||filters[key].some(value=>(card[key]||[]).includes(value)));
    return facetsMatch&&has('type',card.type)&&has('brand',card.brand)&&has('color',card.color)&&matchingVariants(card,filters).length>0;
  }
  function filterVariant(card,filters,preferPrice=false){
    const matching=matchingVariants(card,filters);
    if(!preferPrice){const original=matching.find(v=>String(v.id)===String(card.variantId));if(original)return original;}
    return matching.reduce((best,v)=>!best||v.price<best.price?v:best,null);
  }
  function variantState(product,selected){
    if(!selected.every(Boolean))return 'choose';
    const variant=matchVariant(product,selected);
    return !variant?'unavailable':variant.available?'add':'soldOut';
  }
  function mediaColor(alt,src,colors){
    const normalize=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/grey/g,'gray').replace(/[^a-z0-9]+/g,' ').trim();
    const choices=colors.map(value=>({value,key:normalize(value)})).filter(item=>item.key).sort((a,b)=>b.key.length-a.key.length);
    const label=normalize(String(alt||'').split(/\s[—–]\s/)[1]);
    const explicit=choices.find(item=>item.key===label);if(explicit)return explicit.value;
    let filename=String(src||'').split('?')[0].split('/').pop()||'';
    try{filename=decodeURIComponent(filename);}catch{}
    const words=' '+normalize(filename)+' ';
    return choices.find(item=>words.includes(' '+item.key+' '))?.value||'';
  }
  function colorImage(product,color){
    const index=product.options.findIndex(option=>/colou?r/i.test(optionName(option)));
    const colors=index<0?[]:optionValues(product,index);
    const matches=(product.media||[]).filter(item=>(!item.media_type||item.media_type==='image')&&mediaColor(item.alt,item.preview_image?.src||item.src,colors)===color&&color);
    const image=matches.find(item=>/\bfront\b/i.test(item.alt||''))||matches[0];
    if(image)return image.preview_image?.src||image.src;
    const variant=product.variants.find(item=>item.options[index]===color&&item.featured_image);
    return variant?.featured_image?.src||variant?.featured_image?.url||product.featured_image;
  }
  function createPageLoader(total,firstPage,initial,fetchPage){
    const cache=new Map([[firstPage,initial]]);let pending;
    const load=onProgress=>{
      if(pending)return pending;
      pending=(async()=>{
        for(let page=1;page<=total;page++){
          if(!cache.has(page))cache.set(page,await fetchPage(page));
          onProgress?.(cache.size,total);
        }
        return Array.from({length:total},(_,i)=>cache.get(i+1)).flat();
      })().finally(()=>{pending=null;});
      return pending;
    };
    return {load};
  }
  function filterPrice(card,filters){
    const matching=matchingVariants(card,filters);
    return matching.length?Math.min(...matching.map(v=>v.price)):card.price;
  }
  const api={scopedSearch,shortTitle,canonicalSize,mediaColor,colorImage,optionName,optionValues,matchVariant,initialSelection,optionAvailable,normalizeWishlist,createQueue,matchesCard,variantState,createPageLoader,filterPrice,matchingVariants,filterVariant};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  scope.MotionCore=api;
})(typeof window!=='undefined'?window:globalThis);

